<div [ngClass]="{ 'loading': loading }" class="single-signup-res">
    <app-confirm-dialog
        [visible]="registerConfirmVisible"
        variant="secondary"
        heading="Confirmation"
        message="Are you sure you want to register member?"
        cancelText="No"
        (confirmed)="confirmSignup()"
        (cancelled)="cancelSignupConfirmation()">
    </app-confirm-dialog>
    <div class="card card-w-title mobile-padding-0">
        <div *ngIf="loadingMembership" class="loader-overlay">
            <p-progressSpinner [style]="{ width: '32px', height: '36px' }" styleClass="custom-spinner" strokeWidth="8"
                fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
        </div>
        <p-accordion [(activeIndex)]="index">
            <p-accordionTab [disabled]="true" [header]='setLabel("detailsHeaderLabel")'>
                <div class="profileImgContainer">
                    <div class="p-g-3 p-md-4 imgstyle">
                        <img style="width: 200px; height: 200px" [src]="
                            requestId && !uploadProfile
                                ? member.profile
                                    ? config.Server + config.memberImagePath + member.profile
                                    : member.gender && member.gender == 'F'
                                    ? 'assets/layout/images/avatarGirlImage.png'
                                    : 'assets/layout/images/avatarBoyImage.png'
                                : member.profile
                                ? member.profile
                                : member.gender && member.gender == 'F'
                                ? 'assets/layout/images/avatarGirlImage.png'
                                : 'assets/layout/images/avatarBoyImage.png'
                        " />
                    </div>
                    <div class="userDetailToolBar">
                        <h3 class="first">{{setLabel("profilePictureLabel")}}</h3>
                        <button (click)="captureImageDialogShow('Cam')" class="">
                            <span class="button p-button-text p-c">
                                <i class="fa fa-camera" aria-hidden="true"></i>
                                &nbsp;{{setLabel("capturePhotoBtnLabel")}}
                            </span>
                        </button>
                        <button (click)="captureImageDialogShow('Upload')" class="">
                            <span class="button p-button-text p-c">
                                <i class="fa fa-upload" aria-hidden="true"></i>
                                &nbsp;{{setLabel("uploadPhotoBtnLabel")}}
                            </span>
                        </button>
                        <button (click)="removeProfileImage()" class="removePhoto">
                            <span class="button p-button-text p-c">
                                <i class="fa fa-times"></i> &nbsp;{{setLabel("removePhotoBtnLabel")}}
                            </span>
                        </button>
                    </div>
                </div>
                <form #memberSignUpForm="ngForm">
                    <div class="p-g-12 single-signup-detail-1-res">
                        <div class="p-g-6" style="text-align: left">
                            <div class="p-g p-fluid">
                                <h3 class="first">
                                    {{setLabel("membershipNumberLabel")}}
                                    <span style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-tags"
                                                aria-hidden="true"></i></span>
                                        <input type="number" pattern="[0-9]+" required pInputText #tagNumber="ngModel"
                                        [placeholder]='setLabel("membershipNumber*PlaceholderLabel")' autocomplete="off" [ngClass]="
                                            tagNumber.invalid &&
                                            (tagNumber.dirty ||
                                                tagNumber.touched)
                                                ? 'errorInput'
                                                : ''
                                        " name="tagNumber" [(ngModel)]="member.tagNumber"
                                            (keydown)="firstFocus($event)" (input)="membershipValidation()" readonly />
                                    </div>
                                    <!-- <div *ngIf=" tagNumber.invalid && (tagNumber.dirty || tagNumber.touched) ">
                                    <div *ngIf="tagNumber.errors.required" class="errorShow">
                                        Please Enter Membership number
                                        correctly.
                                    </div>
                                    <div *ngIf="tagNumber.errors.pattern" class="errorShow">
                                        Please Enter Membership number
                                        correctly.
                                    </div>
                                    </div>
                                    <div *ngIf="x == true" class="errorShow">
                                    Membership number already exists
                                </div> -->
                                </div>

                                <h3 class="first">
                                    {{setLabel("nameLabel")}}
                                    <span style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-user"
                                                aria-hidden="true"></i></span>
                                        <input maxlength="100" autocomplete="off" id="memberName" pattern="[A-Za-z ]+"
                                            [ngClass]="
                                            memberName.invalid &&
                                            (memberName.dirty ||
                                                memberName.touched)
                                                ? 'errorInput'
                                                : ''
                                        " type="text" autofocus pInputText [placeholder]='setLabel("name*PlaceholderLabel")' #memberName="ngModel"
                                            name="name" required [(ngModel)]="member.name" />
                                    </div>
                                    <div *ngIf="
                                        memberName.invalid &&
                                        (memberName.dirty || memberName.touched)
                                    ">
                                        <div *ngIf="memberName.errors.required" class="errorShow">
                                            {{setLabel("nameErrorLabel")}}
                                        </div>
                                        <div *ngIf="memberName.errors.pattern" class="errorShow">
                                            {{setLabel("nameLettersErrorLabel")}}
                                        </div>
                                    </div>
                                </div>
                                <h3 class="first">{{setLabel("genderLabel")}}</h3>
                                <div class="gender-opt-detail p-g-12">
                                    <div class="gender-option p-g-6">
                                        <p-radioButton name="gender" value="M" [label]='setLabel("maleLabel")' id="gender"
                                            [(ngModel)]="member.gender" inputId="opt1" [ngClass]="
                                            member.gender === 'M' &&
                                            currentStep == 1
                                                ? 'radioBtnHighlite'
                                                : ''
                                        ">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-6">
                                        <p-radioButton name="gender" value="F" [label]='setLabel("femaleLabel")' id="gender"
                                            [(ngModel)]="member.gender" inputId="opt2" [ngClass]="
                                            member.gender === 'F' &&
                                            currentStep == 1
                                                ? 'radioBtnHighlite'
                                                : ''
                                        ">
                                        </p-radioButton>
                                    </div>
                                </div>

                                <h3 class="first">
                                    {{setLabel("mobileLabel")}}
                                    <span style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <app-phone-input
                                    [placeholder]="setLabel('mobile*PlaceholderLabel')"
                                    [(phoneNumber)]="member.contactDetail.contact"
                                    [initialCountry]="'PK'"
                                    (validNumber)="formattedNumber = $event"
                                    (formattedForSaving)="member.contactDetail.contact = $event"
                                    (isValidNumber)="isNumberLengthValid = $event"
                                    style="max-width: 600px; margin: auto; align-items: center;">
                                </app-phone-input>
                                <div *ngIf="!member.contactDetail.contact" class="validation-error"
                                style="color: red; text-align: start; margin-left: 1.7em;">
                                    {{setLabel("enterMobileNumberErrorLabel")}}
                                  </div>
                                </div>
                                <h3 class="first">
                                    {{setLabel("emailLabel")}}
                                    <span *ngIf="isFieldRequired('email')" style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-envelope-o"
                                                aria-hidden="true"></i></span>
                                        <input maxlength="256" type="email" autocomplete="off" pInputText
                                        [placeholder]='setLabel("emailPlaceholderLabel")' name="email" #email="ngModel" id="email"
                                            (input)="checkEmailExistEvent($event.target.value)"
                                            [required]="isFieldRequired('email')"
                                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                            [(ngModel)]="member.email" />
                                    </div>
                                    <div *ngIf="isEmailExist" class="errorShow">
                                        {{setLabel("emailTakenErrorLabel")}}
                                    </div>
                                    <div *ngIf="email.invalid && (email.dirty || email.touched) ">
                                        <div *ngIf="email.errors.required" class="errorShow">
                                            {{setLabel("emailErrorLabel")}}
                                        </div>

                                        <div *ngIf="email.errors.pattern" class="errorShow">
                                            {{setLabel("validEmailErrorLabel")}}

                                        </div>
                                    </div>

                                    <div class="p-g-4" style="padding-top: 2px">
                                        <ng-template [ngIf]="isEmailLoader">
                                            <div class="p-g-12" style="
                                                text-align: end;
                                                padding-top: 0px;
                                                padding-right: 0px;
                                            ">
                                                <div class="spinit">
                                                    <i class="fa fa-spinner" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                                 <h3 class="first">{{setLabel("bloodGroupLabel")}}</h3>
                                <p-dropdown class="p-inputtext"
                                    [options]="bloodGroupOptions"
                                    name="bloodGroup"
                                    [(ngModel)]="member.bloodGroup" (onChange)="onBloodGroupChange($event)">
                                </p-dropdown>
                                <h3 class="first">{{setLabel('heightLabel')}}</h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-arrows-v" aria-hidden="true"></i></span>
                                        <input type="number" pInputText placeholder="Enter Height" name="height" [(ngModel)]="member.height" />
                                    </div>
                                </div>

                                <h3 class="first">{{setLabel('weightLabel')}}</h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-heartbeat" aria-hidden="true"></i></span>
                                        <input type="number" pInputText placeholder="Enter Weight" name="weight" [(ngModel)]="member.weight" />
                                    </div>
                                </div>

                                <div class="p-g-12" *ngIf="branch?.permissions?.isreferralSourceAllowed">
                                    <h3 class="first">
                                        {{ setLabel("referralSourceLabel") }}
                                        <span style="color: red;">*</span>
                                    </h3>
                                    <div class="p-inputgroup">
                                        <p-dropdown class="p-inputtext" [options]="referralOptions" name="referralSource" id="referralSource" required
                                            [(ngModel)]="member.referralSource" #referralSource="ngModel"
                                            [placeholder]="setLabel('selectReferralSourcePlaceholderLabel')">
                                        </p-dropdown>
                                    </div>
                                    <small style="color: red;" class="p-error" *ngIf="referralSource.invalid && (referralSource.dirty || referralSource.touched)">
                                        {{ setLabel('selectReferralSourcePlaceholderLabel') }}
                                    </small>
                                    <div *ngIf="member?.referralSource === 'Other'" class="p-g-12" style="margin-top: 10px">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">
                                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                            </span>
                                            <input pInputText autocomplete="off" required maxlength="300" type="text" name="otherReferralSource"
                                                [(ngModel)]="member.referralOther" #otherReferral="ngModel"
                                                [placeholder]="setLabel('otherReferralLabel')" />
                                        </div>
                                        <small style="color: red;" class="p-error" *ngIf="otherReferral?.invalid && (otherReferral?.dirty || otherReferral?.touched)">
                                            {{ setLabel('otherReferralLabel') }}
                                        </small>
                                    </div>
                                </div>

                                <!-- <div class="p-g-8" style="padding-top: 0px">
                                    <ng-template *ngIf="
                                            email.invalid &&
                                            (email.dirty || email.touched)
                                        ">
                                        <div>
                                            <div *ngIf="email.errors.required" class="errorShow">
                                                Email is required.
                                            </div>
                                            <div *ngIf="email.errors.pattern" class="errorShow">
                                                Please Enter Email Correctly.
                                                e.g (john@examle.com)
                                            </div>
                                        </div>
                                    </ng-template>

                                    <ng-template [ngIf]="isEmailExist">
                                        <div style="
                                                margin-left: 30px !important;
                                                color: red !important;
                                            ">
                                            Email already taken
                                        </div>
                                    </ng-template>
                                </div> -->
                            </div>
                        </div>

                        <div class="p-g-6" style="text-align: left">
                            <div class="p-g p-fluid">
                                <h3 class="first">{{setLabel("joiningDateLabel")}}</h3>
                                <div class="p-g-12">
                                    <p-calendar [yearNavigator]="true" autofocus="true" inline="true"
                                        yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="member.joiningDate"
                                        id="joiningDate" [placeholder]='setLabel("joiningDatePlaceholderLabel")' name="joinDate" [inline]="false"
                                        dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="isJoiningDateLocked()"
                                        [disabled]="isJoiningDateLocked()">
                                    </p-calendar>
                                </div>
                                <h3 class="first">
                                    {{setLabel("dateOfBirthLabel")}}
                                    <span *ngIf="isFieldRequired('dateOfBirth')" style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <p-calendar [(ngModel)]="member.dateOfBirth" (ngModelChange)="onDateOfBirthChange()"
                                        [placeholder]="setLabel('dateOfBirthPlaceholderLabel')" name="dateOfBirth" [inline]="false" dateFormat="dd/mm/yy"
                                        [showIcon]="true" [maxDate]="maxDate" [required]="isFieldRequired('dateOfBirth')" #dateOfBirth="ngModel"
                                        [ngClass]="{'errorInput': dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)}">
                                    </p-calendar>
                                    <div *ngIf="dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)">
                                        <div *ngIf="dateOfBirth.errors?.required" class="errorShow">
                                            {{setLabel("dateOfBirthErrorLabel")}}
                                        </div>
                                    </div>
                                    <div *ngIf="!isAgeValid" class="errorShow">
                                        {{setLabel("selectedPackageNotAgeGroupLabel")}}
                                    </div>
                                    <div *ngIf="dateOfBirthError" class="errorShow">
                                        {{setLabel("dateOfBirthErrorLabel")}}
                                    </div>
                                </div>
                                                                <div class="p-g-12">
                                    <h3 class="first">{{setLabel("identityTypeLabel")}}</h3>
                                    <div style="display: flex; gap: 3rem;" class="p-g-12">
                                        <p-radioButton name="identityType" [value]="'CNIC'" [(ngModel)]="selectedIdentityType"
                                             label="{{setLabel('cNICLabel')}}"></p-radioButton>
                                        <p-radioButton name="identityType" [value]="'Passport'" [(ngModel)]="selectedIdentityType"
                                             label="{{setLabel('passportLabel')}}"></p-radioButton>
                                    </div>
                                </div>
                                <div *ngIf="selectedIdentityType === 'CNIC'" class="p-g-12">
                                    <h3 class="first">
                                        {{setLabel("cNICLabel")}}
                                        <span *ngIf="isFieldRequired('CNIC')" style="color: red; margin-left: 5px;">*</span>
                                    </h3>
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-id-card" aria-hidden="true"></i></span>
                                        <input
                                            id="CNIC"
                                            [required]="isFieldRequired('CNIC')"
                                            type="text"
                                            autocomplete="off"
                                            pInputText
                                            #CNIC="ngModel"
                                            minlength="13"
                                            maxlength="13"
                                            pattern="[0-9]{13}"
                                            inputmode="numeric"
(input)="restrictCNICInput($event)"
                                            [placeholder]="member.CNIC ? '' : setLabel('cNICLabel')"
                                            name="CNIC"
                                            [(ngModel)]="member.CNIC"
                                         />
                                    </div>
                                    <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)">
                                        <div *ngIf="CNIC.errors?.required" class="errorShow">
                                            {{setLabel("cNICErrorLabel")}}
                                        </div>
                                        <div class="errorShow">
                                            <small *ngIf="CNIC.errors?.minlength">{{setLabel("cNIC13DigitsErrorLabel")}}</small>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="selectedIdentityType === 'Passport'" class="p-g-12">
                                    <h3 class="first">
                                        {{setLabel("passportLabel")}}
                                        <span *ngIf="isFieldRequired('passport')" style="color: red; margin-left: 5px;">*</span>
                                    </h3>
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-id-card" aria-hidden="true"></i></span>
                                        <input
                                            id="passport"
                                            [required]="isFieldRequired('passport')"
                                            type="text"
                                            autocomplete="off"
                                            pInputText
                                            #passport="ngModel"
                                            minlength="9"
                                            maxlength="9"
                                            pattern="[A-Za-z0-9]+"
                                            [placeholder]="member.CNIC ? '' : setLabel('passportLabel')"
                                            name="passport"
                                            [(ngModel)]="member.CNIC"
                                         />
                                    </div>
                                    <div *ngIf="passport.invalid && (passport.dirty || passport.touched)">
                                        <div *ngIf="passport.errors?.required" class="errorShow">
                                            {{setLabel("passportErrorLabel")}}
                                        </div>
                                        <div class="errorShow">
                                            <small *ngIf="passport.errors?.minlength">{{setLabel("passport8DigitsErrorLabel")}}</small>
                                        </div>
                                    </div>
                                </div>
                                <h3 class="first">
                                    {{setLabel("emergencyContactNameLabel")}}
                                </h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-user"
                                                aria-hidden="true"></i></span>
                                        <input maxlength="100" autocomplete="off" id="emergencyName" pattern="[A-Za-z ]+"
                                          type="text" autofocus pInputText [placeholder]='setLabel("emergencyContactNamePlaceholderLabel")' #emergencyName="ngModel"
                                          name="emergencyName" [(ngModel)]="member.emergencyContact.name" />
                                    </div>
                                    <div *ngIf="
                                        emergencyName.invalid &&
                                        (emergencyName.dirty || emergencyName.touched)
                                    ">
                                        <div *ngIf="emergencyName.errors.pattern" class="errorShow">
                                           {{setLabel("nameLettersErrorLabel")}}
                                        </div>
                                    </div>
                                </div>
                                <h3 class="first">
                                    {{setLabel("emergencyContactMobileLabel")}}
                                </h3>
                                <div class="p-g-12">
                                    <app-phone-input
                                    [placeholder]="setLabel('mobile*PlaceholderLabel')"
                                    [(phoneNumber)]="member.emergencyContact.contact"
                                    [initialCountry]="'PK'" [required]="false"
                                    (validNumber)="formattedNumber = $event"
                                    (formattedForSaving)="member.emergencyContact.contact = $event"
                                    style="max-width: 600px; margin: auto; align-items: center;">
                                </app-phone-input>
                                </div>
                                <h3 class="first">{{setLabel("addressLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-g-6">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon"><i class="fa fa-map-marker"
                                                    aria-hidden="true"></i></span>
                                            <input maxlength="256" type="text" pInputText [placeholder]='setLabel("streetPlaceholderLabel")'
                                                id="street" name="street" autocomplete="off" [(ngModel)]="
                                                member.contactDetail.address
                                                    .street
                                            " class="form-control" />
                                        </div>
                                    </div>

                                    <div class="p-g-3">
                                        <div class="p-inputgroup">
                                            <!-- <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span> -->
                                            <input type="text" pInputText [placeholder]='setLabel("cityPlaceholderLabel")' name="city"
                                                autocomplete="off" [(ngModel)]="
                                                member.contactDetail.address
                                                    .city
                                            " id="city" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="p-g-3">
                                        <div class="p-inputgroup">
                                            <!-- <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span> -->
                                            <input type="text" pInputText [placeholder]='setLabel("countryPlaceholderLabel")' name="country"
                                                autocomplete="off" [(ngModel)]="
                                                member.contactDetail.address
                                                    .country
                                            " id="country" class="form-control" />
                                        </div>
                                    </div>
                                </div>

                                <!-- <h3 class="first">
                                    {{setLabel("covid?Label")}}
                                </h3>
                                <div class="covid-Option-Detail p-g-12">
                                    <div class="covid-option p-g-6">
                                        <p-radioButton id="question1" name="question1" value="YES" [label]='setLabel("yesLabel")'
                                            [(ngModel)]="member.question1" inputId="opt1" [ngClass]="
                                            member.question1 === 'YES' &&
                                            currentStep == 7
                                                ? 'radioBtnHighlite'
                                                : ''
                                        ">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-6">
                                        <p-radioButton name="question1" value="NO" [label]='setLabel("noLabel")'
                                            [(ngModel)]="member.question1" inputId="opt2" [ngClass]="
                                            member.question1 === 'NO' &&
                                            currentStep == 7
                                                ? 'radioBtnHighlite'
                                                : ''
                                        ">
                                        </p-radioButton>
                                    </div>
                                </div> -->

                                <h3 class="first">Selected Package</h3>

<div
    class="p-g-12"
    style="padding-left: 35px; padding-right: 7px; box-sizing: border-box; position: relative;"
>
    <i
        class="pi pi-box"
        style="position: absolute; left: 10px; top: 10px; color: #777;"
    ></i>

    <p-dropdown
        [options]="matchingLimitPackages"
        [(ngModel)]="subPackage"
        name="selectedPackage"
        optionLabel="packageName"
        dataKey="_id"
        (onChange)="onPackageChange($event.value)"
        [style]="{
            'width': 'calc(100% - 8px)',
            'height': '34px',
            'border': '1px solid #888888',
            'border-radius': '0',
            'background-color': '#ffffff',
            'font-size': '14px'
        }"
    >
    </p-dropdown>
</div>
                                <h3 class="first">{{setLabel("commentLabel")}}</h3>
                                <div class="comment-Box-Below-text p-g-12">
                                    <textarea maxlength="4096" rows="5" cols="67" id="description" name="description"
                                        [(ngModel)]="member.description" pInputTextarea [placeholder]="member.description ? '' : 'Enter Your Comments Here'"></textarea>
                                    <div>
                                        <p style="
                                            margin-top: 0px;
                                            font-size: smaller;
                                            font-family: inherit;
                                        ">
                                            {{setLabel("pressLabel")}}&nbsp;<span style="
                                                font-weight: bold;
                                                font-family: monospace;
                                            ">{{setLabel("sHift+EnterLabel")}}</span>&nbsp;{{setLabel("nextLineLabel")}}
                                        </p>
                                    </div>
                                </div>
                                </div>
                        </div>
                    </div>
                    <div class="p-g-12">
                        <input type="button" id="back" style="width: 147px !important; border-radius: 5px"
                            (click)="goBack()" class="p-button p-widget p-state-default p-corner-all"
                            value="Back" />
                        &nbsp;&nbsp;
                        <input type="button" id="proceed" style="width: 147px !important; border-radius: 5px"
                            (click)="validateMembersSignup(memberSignUpForm)" [disabled]="isDisableOnTypeEmail || !isAgeValid ||!isNumberLengthValid"
                            class="p-button p-widget p-state-default p-corner-all" [value]='setLabel("proceedValueLabel")' />
                        &nbsp;&nbsp;
                    </div>
                </form>

                <!-- </p-accordionTab> -->
                <div style="clear: both"></div>

                <!-- <p-accordionTab [disabled]="true" header="Personal Training
            Session ?"> -->
                <div class="p-g-12">
                    <form #trainerForm>
                        <!-- <div class="p-g">
                        <h3 class="first">
                            Personal Training Session ?
                        </h3>
                        <div class="p-g-12">
                            <div class="p-g-2">
                                <p-radioButton name="question3" value="YES" label="YES"
                                    [(ngModel)]="member.question3" inputId="opt5" class="p-label-active">
                                </p-radioButton>
                            </div>
                            <div class="p-g-2">
                                <p-radioButton name="question3" value="NO" label="NO"
                                    [(ngModel)]="member.question3" inputId="opt6">
                                </p-radioButton>
                            </div>
                        </div>

                        <div class="p-g-6" *ngIf="member.question3 ==
                            'YES'">
                            <span style="color: #000000 !important">Trainer
                                Fee DueDate(F9):&nbsp;
                                <p-calendar [yearNavigator]="true" id="tFeeDueDate" yearRange="1950:2040"
                                    [monthNavigator]="true" required [ngModelOptions]="{
                                    standalone: true
                                    }" [(ngModel)]="member.customerstrainer.dueDate" placeholder="DueDate"
                                    name="trainerDueDate" #dueDate="ngModel" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true">
                                </p-calendar>
                            </span>
                            <div *ngIf="dueDate.invalid &&
                                (dueDate.dirty || dueDate.touched)">
                                <div *ngIf="dueDate.errors.required" class="errorShow">
                                    Due Date is required.
                                </div>
                                <div *ngIf="dueDate.errors.pattern" class="errorShow">
                                    Only Characters are Allowed.
                                </div>
                            </div>
                        </div>

                        <div class="p-g-6" *ngIf="member.question3 ==
                            'YES'">
                            <span style="color: #000000 !important">Trainer
                                Fee:
                                <input style="width: 75% !important" type="number" autocomplete="off"
                                    id="trainerFee" (keydown)="trainerShareFocus($event)" required pInputText
                                    placeholder="Trainer Fee" name="totalFees" [(ngModel)]="member.customerstrainer
                                    .totalFees" /></span>&nbsp;
                            &nbsp;&nbsp;
                        </div>
                        <div class="p-g-6" *ngIf="member.question3 ==
                            'YES'">
                            <span style="color: #000000 !important">Select
                                the trainer(F4): </span>&nbsp;
                            <p-dropdown [ngModelOptions]="{ standalone:
                                true }" (keydown)="gymShareFocus($event)" id="selectTrainer"
                                [options]="options" [(ngModel)]="selectedOption" (onChange)="dropdownChange()">
                            </p-dropdown>
                            &nbsp;&nbsp;
                        </div>
                        <div class="p-g-6" *ngIf="member.question3 ==
                            'YES'">
                            <span style="color: #000000 !important">Trainer
                                share:
                                <input style="width: 75% !important" type="number" autocomplete="off"
                                    id="trainerShare" required pInputText placeholder="Trainer Share" name="trainerShare" [(ngModel)]="member.customerstrainer
                                    .trainerShare" /></span>&nbsp;
                            &nbsp;&nbsp;
                        </div>
                        <div class="p-g-6" *ngIf="member.question3 ==
                            'YES'">
                            <span style="color: #000000 !important">Gym
                                share:
                                <input style="width: 44% !important" type="number" autocomplete="off"
                                    id="gymShare" (keydown)="trainerFeeFocus($event)" required pInputText
                                    placeholder="Gym Share" name="gymShare"
                                    [(ngModel)]="member.customerstrainer.gymShare" /></span>
                            &nbsp; &nbsp;&nbsp;
                        </div>
                    </div> -->
                        <!-- <button id="loginbtn" [disabled]="loading" (click)="reverse()"
        class="p-button p-widget p-state-default p-corner-all">
        <span class="p-button-text p-c">back</span>
        <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin"
            style="font-size:24px"></span>
        </button>&nbsp;&nbsp; -->

                        <!-- <button id="nextBtn" *ngIf="!isMembersRegistered ||
                        subPackage.isGreaterthanNoOfMembers" [disabled]="!trainerForm.form.valid"
                            (click)="nextMembers()" class="p-button
                        p-widget
                        p-state-default
                        p-corner-all">
                            <span class="p-button-text p-c">Next Member</span>
                            <span *ngIf="loading" class="p-button-icon-left
                            p-c
                            fa fa-spinner fa-spin" style="font-size:
                            24px"></span>
                        </button> -->
                    </form>
                </div>
                <div style="clear: both"></div>
                <!-- </p-accordionTab> -->
            </p-accordionTab>

            <div style="clear: both"></div>

            <p-accordionTab [disabled]="true" [header]='setLabel("registerBtnLabel")'>
                <div class="p-g single-signup-detail-2-res">
                    <div class="p-g-12 personal-training-session">
                        <form #trainerNewForm>
                            <div class="p-g" *ngIf="noOfMembers === 1">
                                <!-- <h3 class="first">{{setLabel("personalTrainingSessionLabel")}} ?</h3>
                                <div class="p-g-12 personal-training-session-radioButton">
                                    <div class="p-g-2">
                                        <p-radioButton name="question3" value="YES" [label]='setLabel("yesLabel")' id="question3Id"
                                            [ngClass]="
                                            member.question3 === 'YES'
                                                ? 'radioBtnHighlite'
                                                : ''
                                        " [(ngModel)]="member.question3" inputId="opt5" class="p-label-active"
                                            (change)="trainerRadioChangeFocus()" (ngModelChange)="
                                            trainerRadioChangeFocus()
                                        ">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-2">
                                        <p-radioButton name="question3" value="NO" [label]='setLabel("noLabel")' class="p-label-active"
                                            (change)="trainerRadioChangeFocus()" (ngModelChange)="
                                            trainerRadioChangeFocus()
                                        " [(ngModel)]="member.question3" inputId="opt6" [ngClass]="
                                            member.question3 === 'NO'
                                                ? 'radioBtnHighlite'
                                                : ''
                                        ">
                                        </p-radioButton>
                                    </div>
                                </div> -->

                                <div class="p-g-6" style="text-align: left" *ngIf="member.question3 == 'YES'">
                                    <h3 class="first">{{setLabel("joiningDateLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                        <div class="p-g-12">
                                            <p-calendar disabled="true" [yearNavigator]="true" yearRange="1950:2040"
                                                [monthNavigator]="true" [(ngModel)]="
                                                    member.customerstrainer
                                                        .dueDate
                                                " [placeholder]='setLabel("dueDatePlaceholderLabel")' name="trainerDueDate" [inline]="false"
                                                dateFormat="dd/mm/yy" [showIcon]="true">
                                            </p-calendar>
                                        </div>

                                        <h3 class="first">{{setLabel("trainerFeeLabel")}}</h3>
                                        <div class="p-g-12">
                                            <div class="p-inputgroup">
                                                <input type="number" autocomplete="off" pattern="[0-9]+" id="trainerFee"
                                                    required #trainerFee="ngModel" pInputText [placeholder]='setLabel("trainerFeePlaceholderLabel")'
                                                    name="trainerFee" [(ngModel)]="
                                                    member.customerstrainer
                                                        .totalFees
                                                " (input)="onChangeTrainerFee()" [ngClass]="
                                                    trainerFee.invalid &&
                                                    (trainerFee.dirty ||
                                                        trainerFee.touched)
                                                        ? 'errorInput'
                                                        : ''
                                                " />
                                            </div>
                                            <div *ngIf="
                                                trainerFee.invalid &&
                                                (trainerFee.dirty ||
                                                    trainerFee.touched)
                                            ">
                                                <div *ngIf="
                                                    trainerFee.errors.required
                                                " style="
                                                    color: red !important;
                                                    margin-top: 4px !important;
                                                ">
                                                    {{setLabel("trainerFeeErrorLabel")}}
                                                </div>
                                                <div *ngIf="
                                                    trainerFee.errors.pattern
                                                " style="
                                                    color: red !important;
                                                    margin-top: 4px !important;
                                                ">
                                                    {{setLabel("trainerFeeErrorLabel")}}
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <div class="p-g-6" style="text-align: left; margin-top: -7px;" *ngIf="member.question3 == 'YES'">
                                    <h3 class="first">{{setLabel("trainerLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                        <div class="p-g-12">
                                            <div class="p-inputgroup">
                                                <p-dropdown [ngModelOptions]="{
                                                    standalone: true
                                                }" id="selectTrainer" [options]="options" [(ngModel)]="selectedOption"
                                                    (onChange)="dropdownChange()" [style]="{ width: '100%' }"
                                                    class="dropdownFull">
                                                </p-dropdown>
                                            </div>
                                    </div>
                                </div>
                                <h3 class="first">{{setLabel("sessionsBookedLabel")}}</h3>
                                <div class="p-g p-fluid">
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                    <input type="number" id="sessionCount" (change)="setSessionCount($event.target.value)">
                                </div>
                            </div>
                                    </div>
                            </div>
                                        <!-- <div class="p-g-12">
                                        <h3 class="first">Gym Share</h3>
                                        <div class="p-inputgroup">
                                            <input type="number" id="gymShare" #gymShare style="width: 100% !important" required pattern="[0-9]+"
                                                autocomplete="off" pInputText placeholder="Gym Share" name="gymShare"
                                                [(ngModel)]="member.customerstrainer.gymShare" #gymShare="ngModel" (input)="getTrainerShare()"
                                                [ngClass]="gymShare.invalid && (gymShare.dirty || gymShare.touched) ? 'errorInput' : ''" />
                                        </div>
                                        <div style="text-align: right; margin-right: 31px;">
                                            <div *ngIf="gymShare.value > gymShare.value" class="errorShow">
                                                Received Fee Must be less than Actual Package Fee.
                                            </div>
                                        </div>
                                        <div *ngIf="gymShare.invalid && (gymShare.dirty || gymShare.touched)" style="text-align: right; margin-right: 31px;">
                                            <div *ngIf="gymShare.errors.required" class="errorShow">
                                                Please Enter Package Fee.
                                            </div>
                                            <div *ngIf="gymShare.errors.pattern" class="errorShow">
                                                Please Enter Fee Correctly.
                                            </div>

                                        </div>

                                    </div> -->

                                <div class="p-g-12" style="text-align: center; padding-top: 15px">
                                    <button id="backToDetails" (click)="index = 0"
                                        class="p-button p-widget p-state-default p-corner-all" type="button">
                                        <span class="p-button-text p-c">Back</span>
                                    </button>
                                    &nbsp;&nbsp;
                                    <button id="register" (click)="signup()"
                                        class="p-button p-widget p-state-default p-corner-all" type="button">
                                        <span class="p-button-text p-c">{{setLabel("registerBtnLabel")}}
                                            <span style="
                                                font-family: none;
                                                font-size: small;
                                                color: limegreen;
                                            ">
                                                {{setLabel("ctrl+EnterLabel")}}</span>
                                        </span>
                                    </button>
                                </div>

                                <!-- <button (click)="signup()" id="register"
                                [disabled]="!trainerNewForm.valid ||  gymShare.value > trainerFee.value" pButton type="button" label="Register"
                                icon="pi pi-save" class="p-button-success">
                            </button> -->

                                <!-- <div class="p-g-6" *ngIf="member.question3 ==
                                'YES'">
                                <span style="color: #000000 !important">DueDate(F9):&nbsp;
                                    <p-calendar [yearNavigator]="true" id="tFeeDueDate" yearRange="1950:2040"
                                        [monthNavigator]="true" required [ngModelOptions]="{
                                        standalone: true
                                        }" [(ngModel)]="member.customerstrainer.dueDate" placeholder="DueDate"
                                        name="trainerDueDate" #dueDate="ngModel" [inline]="false" dateFormat="dd/mm/yy"
                                        [showIcon]="true">
                                    </p-calendar>
                                </span>
                                <div *ngIf="dueDate.invalid &&
                                    (dueDate.dirty || dueDate.touched)">
                                    <div *ngIf="dueDate.errors.required" class="errorShow">
                                        Due Date is required.
                                    </div>
                                    <div *ngIf="dueDate.errors.pattern" class="errorShow">
                                        Only Characters are Allowed.
                                    </div>
                                </div>
                            </div>

                            <div class="p-g-6" *ngIf="member.question3 ==
                                                        'YES'">
                                <span style="color: #000000 !important">Trainer</span>&nbsp;
                                <p-dropdown [ngModelOptions]="{ standalone: true }" id="selectTrainer" [options]="options"
                                    [(ngModel)]="selectedOption" (onChange)="dropdownChange()">
                                </p-dropdown>
                                &nbsp;&nbsp;
                            </div>

                            <div class="p-g-12" style="padding-top: 15px;">

                                <div class="p-g-4" *ngIf="member.question3 == 'YES'">
                                    <span style="color: #000000 !important">Trainer Fee:
                                        <input type="number" autocomplete="off" id="trainerFee" required #trainerFee="ngModel"
                                            pInputText placeholder="Trainer Fee" name="totalFees" [(ngModel)]="member.customerstrainer.totalFees"
                                            [ngClass]="trainerFee.invalid && (trainerFee.dirty ||
                                            trainerFee.touched)
                                            ? 'errorInput'
                                            : ''" />
                                        </span>&nbsp;
                                    &nbsp;&nbsp;
                                </div>

                                <div class="p-g-4" style="text-align: center;" *ngIf="member.question3 =='YES'">
                                    <span style="color: #000000 !important">Gym share:
                                        <input type="number" autocomplete="off" id="gymShare" required pInputText (input)="getTrainerShare()"
                                            placeholder="Gym Share" name="gymShare" #gymShare="ngModel"  [(ngModel)]="member.customerstrainer.gymShare"
                                            [ngClass]="gymShare.invalid && (gymShare.dirty ||
                                            gymShare.touched)
                                            ? 'errorInput'
                                            : ''"/></span>
                                    &nbsp; &nbsp;&nbsp;

                                </div>

                                <div class="p-g-4" style="text-align: left;" *ngIf="member.question3 =='YES'">
                                    <span style="color: #000000 !important">Trainer share:
                                        <input type="number" autocomplete="off" id="trainerShare" required pInputText placeholder="Trainer Share"
                                            name="trainerShare" [(ngModel)]="member.customerstrainer.trainerShare"/></span>&nbsp;
                                    &nbsp;&nbsp;
                                </div>
                            </div> -->
                            </div>
                        </form>
                    </div>
                </div>
            </p-accordionTab>
            <div style="clear: both"></div>
        </p-accordion>
    </div>
    <div class="p-g-12">
        <!-- <button id="loginbtn" [disabled]="loading" (click)="reverse()"
class="p-button p-widget p-state-default p-corner-all">
<span class="p-button-text p-c">back</span>
<span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
</button>&nbsp;&nbsp;
<button id="loginbtn" *ngIf="package.noOfMembers==index-1" [disabled]="!memberSignUpForm.form.valid"
(click)="validateSignup()" class="p-button p-widget p-state-default p-corner-all">
<span class="p-button-text p-c">Next</span>
<span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
</button> -->
    </div>
    <!-- <div class="card card-w-title" *ngIf="activeIndex == 2">
<div class="p-g-12">
<div class="p-g">
<h3 class="first">Personal Training Session ?</h3>
<div class="p-g-12">
  <div class="p-g-2">
    <p-radioButton name="question3" value="YES" label="YES" [(ngModel)]="member.question3" inputId="opt5">
    </p-radioButton>
  </div>
  <div class="p-g-2">
    <p-radioButton name="question3" value="NO" label="NO" [(ngModel)]="member.question3" inputId="opt6">
    </p-radioButton>
  </div>
</div>
<div class="p-g-6" *ngIf="member.question3=='YES'">
  <span style="color: #000000 !important">Select the trainer: </span>&nbsp; <p-dropdown [options]="options"
    [(ngModel)]="selectedOption" (onChange)="dropdownChange()"></p-dropdown>&nbsp;&nbsp;
</div>
<div class="p-g-6" *ngIf="member.question3=='YES'">
  <span style="color: #000000 !important;">Trainer Fee: <input style="width:75% !important" type="number"
      autocomplete="off" required pInputText placeholder="Trainer Fee" name="customerstrainer"
      [(ngModel)]="member.customerstrainer.totalFees"></span>&nbsp; &nbsp;&nbsp;
</div>
<div class="p-g-6" *ngIf="member.question3=='YES'">
  <span style="color: #000000 !important;">Trainer Fee DueDate:
    <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
      [(ngModel)]="member.customerstrainer.dueDate" placeholder="DueDate" name="trainerDueDate" [inline]="false"
      dateFormat="dd/mm/yy" [showIcon]="true">
    </p-calendar></span>
</div>
<div class="p-g-6" *ngIf="member.question3=='YES'">
  <span style="color: #000000 !important;">Trainer share: <input style="width:75% !important" type="number"
      autocomplete="off" required pInputText placeholder="Trainer Share" name="customerstrainer"
      [(ngModel)]="member.customerstrainer.trainerShare"></span>&nbsp;
  &nbsp;&nbsp;
</div>
<div class="p-g-6" *ngIf="member.question3=='YES'">
  <span style="color: #000000 !important;">Gym share: <input style="width:44% !important" type="number"
      autocomplete="off" required pInputText placeholder="Gym Share" name="customerstrainer"
      [(ngModel)]="member.customerstrainer.gymShare"></span> &nbsp; &nbsp;&nbsp;
</div>
</div>
<button id="loginbtn" *ngIf="isMembersRegistered" [disabled]="loading" (click)="reverse()"
class="p-button p-widget p-state-default p-corner-all">
<span class="p-button-text p-c">back</span>
<span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
</button>&nbsp;&nbsp;
<button id="nextBtn" *ngIf="!isMembersRegistered" (click)="signup()"
class="p-button p-widget p-state-default p-corner-all">
<span class="p-button-text p-c">Register</span>
<span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
</button>
</div>
<div style="clear: both;"></div>
</div> -->
    <!-- <div class="card card-w-title" style="text-align: left !important" *ngIf="activeIndex == 2">
<div class="p-g">
    <div class="p-g-12">
        <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading">
            <ng-template pTemplate="header">
                <tr>
                    <th>MemberShip No</th>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Select Trainer</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-membercard>
                <tr>
                    <td>{{ membercard.tagNumber }}</td>
                    <td>{{ membercard.name }}</td>
                    <td>{{ membercard.contactDetail.contact }}</td>
                    <td>
                        <div class="p-g-6">
                            <p-dropdown [ngModelOptions]="{ standalone:true }" (keydown)="gymShareFocus($event)"
                                id="selectTrainer" [options]="options"
                                [(ngModel)]="membercard.customerstrainer.trainerId"
                                (onChange)="dropdownChange()">
                            </p-dropdown>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div class="p-g-12">
        <div class="p-g-4"></div>
        <div class="p-g-4" style="text-align: center">
            &nbsp;&nbsp;
            <button id="nextBtn" *ngIf="this.isMembersRegistered" (click)="signup()"
                [disabled]="!trainerForm.form.valid" class="p-button
                        p-widget
                        p-state-default
                        p-corner-all">
                <span class="p-button-text p-c">Register</span>
            </button>
        </div>
        <div class="p-g-4"></div>
    </div>
</div>
</div> -->
    <div class="card card-w-title mobile-padding-0" style="text-align: left !important" *ngIf="activeIndex == 2">
        <div class="p-g">
            <!-- <button class="p-button p-widget p-state-default p-corner-all">
<span class="p-button-text p-c" (click)="feeInvoice()"><i class="fa fa-check"
    aria-hidden="true"></i>&nbsp;&nbsp;Collect Fees</span>
</button> -->
            <div class="p-g-12">
                <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading"
                    class="p-table-tecfolk-fix">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{setLabel("memberShipNoLabel")}}</th>
                            <th>{{setLabel("nameLabel")}}</th>
                            <th>{{setLabel("joiningDateLabel")}}</th>
                            <th>{{setLabel("contactLabel")}}</th>
                            <th>{{setLabel("trainerFeesLabel")}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-membercard>
                        <tr>
                            <td>{{ membercard.tagNumber }}</td>
                            <td>{{ membercard.name }}</td>
                            <td>
                                {{ membercard.joiningDate | date : "dd/MM/yyyy" }}
                            </td>
                            <td>{{ membercard.contactDetail.contact }}</td>
                            <td>{{ membercard.customerstrainer.totalFees }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div class="p-g-12">
                <div class="p-g-4"></div>
                <div class="p-g-4" style="text-align: center">
                    <!-- <button class="p-button p-widget p-state-default p-corner-all" (click)="print()">
    <span class="p-button-text p-c"><i class="fa fa-print" aria-hidden="true"></i>&nbsp;&nbsp;Print</span>
  </button>&nbsp;&nbsp; -->
                    <!-- <button class="p-button p-widget p-state-default p-corner-all">
    <span class="p-button-text p-c" (click)="finish()"><i class="fa fa-check"
        aria-hidden="true"></i>&nbsp;&nbsp;Finish</span>
  </button> -->
                    &nbsp;&nbsp;
                    <button class="p-button p-widget p-state-default p-corner-all">
                        <span class="p-button-text p-c"><i class="fa fa-check"
                                aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("collectFeesLabel")}} (F2)</span>
                    </button>
                </div>
                <div class="p-g-4"></div>
            </div>
        </div>
    </div>
    <div class="card card-w-title mobile-padding-0" style="text-align: left !important" *ngIf="activeIndex == 3">
        <!-- Montly Fee -->
        <div class="p-g">
            <div class="p-g-12">
                <div style="padding: 0px !important; margin: auto !important">
                    <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{setLabel("memberShipNoLabel")}}</th>
                                <th>{{setLabel("nameLabel")}}</th>
                                <th>{{setLabel("dueDateLabel")}}</th>
                                <th>{{setLabel("feesLabel")}}</th>
                                <th>{{setLabel("registrationFeeLabel")}}</th>
                                <th>{{setLabel("contactLabel")}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-memberFees>
                            <tr>
                                <td>{{ memberFees.tagNumber }}</td>
                                <td>{{ memberFees.name }}</td>
                                <td>
                                    {{
                                    memberFees.joiningDate | date : "dd/MM/yyyy"
                                    }}
                                </td>
                                <td>{{ memberFees.monthFee }}</td>
                                <td>{{ memberFees.registerationFee }}</td>
                                <td>{{ memberFees.contactDetail.contact }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

        <br />
        <div style="text-align-last: center">
            <button class="p-button p-widget p-state-default p-corner-all">
                <span class="p-button-text p-c" (click)="printInvoice()"><i class="fa fa-check"
                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("printBtnLabel")}}
                    <span style="
                        font-family: none;
                        font-size: small;
                        color: limegreen;
                    ">
                        (P)</span>&nbsp;&nbsp;</span>
            </button>
            &nbsp;&nbsp;
            <button class="p-button p-widget p-state-default p-corner-all">
                <span class="p-button-text p-c" (click)="finish()"><i class="fa fa-check"
                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("finishBtnLabel")}}
                    <span style="
                        font-family: none;
                        font-size: small;
                        color: limegreen;
                    ">
                        (F)</span></span>
            </button>
        </div>
        <div style="clear: both"></div>
    </div>

    <!-- <div *ngIf="dialogVisibility">
    <p-dialog header="Capture Photo" [(visible)]="dialogVisibility">
        <app-camera (pictureTaken)="handleImage($event)"></app-camera>
    </p-dialog>
</div> -->

    <div *ngIf="dialogVisibility" class="tecfolkProfileDialogFix">
        <p-dialog [header]='setLabel("addProfilePhotoHeaderLabel")' [(visible)]="dialogVisibility" class="app-add-profile-image-tecfolk-fix">
            <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
                (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
        </p-dialog>
        <!-- popupType : Upload | Cam -->
    </div>
    <!-- <p-dialog header="Add Fee" [closeOnEscape]="true" [(visible)]="feeInvoiceDialog">
    <form #feeForm style="height: 250px; width: 570px">

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">Package Fee </span>
                <input type="number" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Price" name="fundPay" [(ngModel)]="totalPackageFee" #fundPay="ngModel"
                    [ngClass]="fundPay.invalid && (fundPay.dirty ||
                    fundPay.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>
            <div *ngIf="fundPay.invalid && (fundPay.dirty || fundPay.touched)">
                <div *ngIf="fundPay.errors.required" class="errorShow">
                    Please Enter Fee Correctly.
                </div>
                <div *ngIf="fundPay.errors.pattern" class="errorShow">
                    Please Enter Fee Correctly.
                </div>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">Registration Fee </span>
                <input type="number" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Price" readonly name="registerationFee"
                    [(ngModel)]="totalRegistrationPackageFee" #registerationFee="ngModel" [ngClass]="registerationFee.invalid
                    &&
                    (registerationFee.dirty || registerationFee.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>
            <div *ngIf="registerationFee.invalid &&
                (registerationFee.dirty || registerationFee.touched)">
                <div *ngIf="fundPay.errors.required" class="errorShow">
                    Please Enter Reg.Fee Correctly.
                </div>
                <div *ngIf="registerationFee.errors.pattern" class="errorShow">
                    Please Enter Reg.Fee Correctly.
                </div>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">Trainer Fee</span>
                <input type="number" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Price" readonly name="totalTrainerFee" [(ngModel)]="totalTrainerFee"
                    #trainerFee="ngModel" [ngClass]="trainerFee.invalid &&
                    (trainerFee.dirty || trainerFee.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>
            <div *ngIf="trainerFee.invalid &&
                (trainerFee.dirty || trainerFee.touched)">
                <div *ngIf="trainerFee.errors.required" class="errorShow">
                    Please Enter Tra.Fee Correctly.
                </div>
                <div *ngIf="trainerFee.errors.pattern" class="errorShow">
                    Please Enter Tra.Fee Correctly.
                </div>
            </div>
        </div>
        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup"></div>
        </div>

        <p-footer>
            <button (click)="addFund()" style="float: right !important; margin-right: 42px !important;"
                [disabled]="!feeForm.valid" pButton type="button" label="Save" icon="pi pi-save"
                class="p-button-success"></button>
        </p-footer>
    </form>
</p-dialog> -->
    <!-- Invoice Print -->
    <!-- <app-receipt-print [company]="company" [members]="members" [fundInvoice]="fundInvoice" [subPackage]="subPackage"
    [totalPackageFee]="totalPackageFee" [totalRegistrationPackageFee]="totalRegistrationPackageFee"
    [totalTrainerFee]="totalTrainerFee"></app-receipt-print> -->
    <ngx-spinner name="mainLoader" bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff"
        type="ball-clip-rotate-multiple" [fullScreen]="true">
        <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
    </ngx-spinner>

</div>